/**
 * `.rl-detail-head` — the eyebrow, the reel's name, its breakdown line, and the
 * one action that puts something on it (CAE-1552).
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';
import { PlusIcon } from '../../../../components/ui';
import type { ContestFixture } from '../../../../api/contests';
import { ReelBreakdown } from './reel-breakdown';
import { ReelName } from './reel-name';
import type { ReelSlot } from './reel-slots';

export interface ReelDetailHeadProps {
  slot: ReelSlot;
  fixturesById: ReadonlyMap<string, ContestFixture>;
  editable: boolean;
  onAddOutcomes: () => void;
  onRename: (label: string) => void;
}

export const ReelDetailHead = ({
  slot,
  fixturesById,
  editable,
  onAddOutcomes,
  onRename,
}: ReelDetailHeadProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: '20px',
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Box
        sx={(theme: Theme) => ({
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: theme.tokens.color.ink4,
          marginBottom: '4px',
        })}
      >
        Editing reel
      </Box>

      <ReelName slot={slot} editable={editable} onRename={onRename} />

      <ReelBreakdown slot={slot} fixturesById={fixturesById} />
    </Box>

    {/*
     * Gated like every other control on the row below it. Adding outcomes is a
     * write — `POST …/reels/:n/options` — and the contest's edit window is what
     * governs it, so a live button on a settled contest only offers an operator
     * a picker whose Save the API will refuse.
     */}
    <Button
      variant="contained"
      startIcon={<PlusIcon />}
      onClick={onAddOutcomes}
      disabled={!editable}
      aria-label={`Add outcomes to ${slot.title}`}
      sx={{ flexShrink: 0 }}
    >
      Add outcomes
    </Button>
  </Box>
);
